import React from "react";
import { Link } from "react-router-dom";
import "./notfound.css";

const NotFound = () => {
  return (
    <div className="nf-container">
      <div className="nf-content">
        <h1 className="nf-code black-text-clip">404</h1>
        <h2 className="nf-title black-text-clip">Page Not Found</h2>
        <p className="nf-text black-text-clip">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <Link to="/" className="nf-btn">
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
